//create a component which will check if api_key and email are present in local storage otherwise redirect to login page

import { useEffect, useState } from "react";
import { getAccessToken } from "../api/authorization"; 

const AuthManager = ({ children }) => {
  const [isLogggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    if (!(getAccessToken())) {
      setIsLoggedIn(false);
      setTimeout(() => {
        window.location.href = process.env.REACT_APP_REDIRECT_URL + "/company/interviews/async-video";
      }, [1000]);
    } else {
      setIsLoggedIn(true);
    }
  }, []);
  return isLogggedIn ? children : null;
};

export default AuthManager;
